import { render, staticRenderFns } from "./ContractSupportForm.vue?vue&type=template&id=68cb2453&"
import script from "./ContractSupportForm.vue?vue&type=script&lang=js&"
export * from "./ContractSupportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports